import api from './api'
import { Notification } from '../types'

export const notificationApi = {
  // 获取通知列表
  getNotifications: async (): Promise<Notification[]> => {
    const response = await api.get('/notifications')
    return response
  },

  // 获取未读通知数量
  getUnreadCount: async (): Promise<number> => {
    const response = await api.get('/notifications/unread-count')
    return response
  },

  // 标记为已读
  markAsRead: async (id: string): Promise<void> => {
    await api.patch(`/notifications/${id}/read`)
  },

  // 标记全部已读
  markAllAsRead: async (): Promise<void> => {
    await api.patch('/notifications/mark-all-read')
  },

  // 删除通知
  deleteNotification: async (id: string): Promise<void> => {
    await api.delete(`/notifications/${id}`)
  },
}
